<template>
    <div>
        <el-tabs v-model="platform">
            <el-tab-pane label="Zoom会议" name="zoom" v-if="hasZoom">
            </el-tab-pane>
            <el-tab-pane label="腾讯会议" name="tencent" v-if="hasTencent">
            </el-tab-pane>
            <el-tab-pane label="Welink" name="welink" v-if="hasWelink">
            </el-tab-pane>
        </el-tabs>
        <!-- 显示会议 -->
        <el-row class="meeting-calendar" v-loading="process.loading">
            <div class="calendar-left">
                <div class="calendar-district">
                    <div>
                        <el-date-picker
                            style="width: auto"
                            size="medium"
                            v-model="target"
                            value-format="yyyy-MM-dd"
                            @change="reload"
                            type="week"
                            format="yyyy-MM-dd"
                            placeholder="选择周">
                        </el-date-picker>
                    </div>
                    <div class="mt-2 d-flex justify-content-between">
                        <el-button type="default" style="padding: 4px 25px;" size="medium"
                                   @click.native='previous' icon="el-icon-arrow-left">
                        </el-button>
                        <el-button type="default" style="padding: 4px 25px;" size="medium"
                                   icon="el-icon-arrow-right"
                                   @click.native='next'>
                        </el-button>
                    </div>

                </div>
                <div>
                    <template v-if="platform==='zoom'">
                        <div class="calender-trow-room" v-for="room in meetingRooms" :key="room.id">
                            <div class="name"> {{ room.name }}
                                <div class="group">{{ room.group_name }}</div>
                                <div class="address">{{ room.email }}</div>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="platform==='welink'">
                        <div class="calender-trow-room" v-for="room in welinkRooms" :key="room.id">
                            <div class="name"> {{ room.name }}
                                <div class="group">{{ room.group_name }}</div>
                                <div class="address">{{ room.email }}</div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="calender-trow-room" v-for="room in tencentRooms" :key="room.id">
                            <div class="name"> {{ room.name }}
                                <div class="group">{{ room.group_name }}</div>
                                <div class="address">{{ room.email }}</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <!-- calendar -->
            <div class="calender-right">
                <div class="wrapper" style="min-width: 700px;">
                    <div class="rule">
                        <div class="relative">
                            <div class="calender-heading-trow">
                                <div class="cell" v-for="(cell,index) in ruleCells" :key="cell"
                                     style="min-width:100px; width: 14.28%; ">
                                    <div class="cell-day">
                                        <div class="day-text">{{ cell.substr(3, 2) }}
                                            <div class="week"><span>星期{{ "日一二三四五六".substr(index, 1) }}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--  分会议室 制作表格 -->
                            <div style="position: relative;" class="calender-meeting">
                                <div class="calender-body-trow"
                                     v-for="room in platform==='zoom'?books:(platform==='tencent'?tencent:welink)" :key="room.id">
                                    <div class="cell" v-for="(records,date) in room.reserves" :key="date">
                                        <div class="book" v-show="index<4"
                                             v-for="(resv,index) in records"
                                             :class="resv.approve === '1'?'submitted':'approved'"
                                             :key="resv.id">
                                            <span>{{ resv.meeting_time.substr(0, 2) }}
                                                <sup>{{ resv.meeting_time.substr(-2) }}</sup>
                                            </span>
                                            {{ resv.host_name }}
                                        </div>
                                        <div class="details" v-if="records && records.length">
                                            <el-button type="text" icon="el-icon-search"
                                                       @click.native="showResv(records,date)">详细信息
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>

            <el-dialog :visible.sync="show_details" :close-on-click-modal="false">
                <div slot="title"><b class="text-info">{{ single.date }} 的预约情况</b></div>
                <div class="meeting-detail-wrap">
                    <div class="meeting-detail" v-for="(record,index) in single.records" :key="record.id">
                        <div class="circle-number">{{ index + 1 }}</div>
                        <div class="meeting-inner">
                            <div class="name">({{ record.id }}) {{ record.host_name }} <small
                                class="text-info ml-2">{{ record.department }}</small>
                                <small class="text-info ml-2">{{ record.department }}
                                    | {{ record.approve === '1' ? '提交' : '批准' }}
                                    <span class="text-danger" v-if="record.option_h323 === '1'"> | 使用H.323 </span>
                                </small>
                            </div>
                            <div class="time mt-1"><b>{{ record.meeting_time }}</b> {{ record.duration_hour }}</div>
                            <div class="author mt-1">{{ record.topic }}</div>

                        </div>
                        <div class="clearfix"></div>

                    </div>

                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="show_details=false">关 闭</el-button>
                </div>

            </el-dialog>

        </el-row>
    </div>
</template>

<script>

import weekview from "@/common/mixins/meeting-weekview"

export default {
    name: "meeting-weekview",
    mixins: [weekview]
}
</script>

<style scoped lang="scss">

$left-bar-bg-color: #f1f1f1;
$right-bar-bg-color: white;
$room-title-color: #2f3538;
$room-email-color: #576B70;
$room-bg-color: #f8f8f8;
$title-color: #607d8b;
$border-left-color: #9e9e9e;
$border-color: #EBEEF5;
$room-group-color: #1d5a94;
$cell-height: 110px;

button {
    outline: none;
}

.meeting-calendar {
    background-color: #f1f1f1;
    border: 2px solid darken($border-color, 10%);

    .calendar-left {
        width: 180px;
        float: left;
        background-color: $left-bar-bg-color;
        overflow: hidden;
        user-select: none;
        padding-bottom: 18px;
        border-right: 1px solid darken($border-color, 10%);

        .calendar-district {
            padding: 5px;
            height: 80px;
            border-bottom: 1px solid $border-color;
            background-color: #f1f3f4;
        }

        .calender-trow-room {
            background-color: $room-bg-color;
            padding: 0 12px 12px;
            position: relative;
            height: $cell-height;
            clear: both;
            border-bottom: 1px solid $border-color;

            .name {
                padding-top: 20px;
                color: $room-title-color;
                font-size: 16px;
                line-height: 20px;
                font-weight: 700;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                .group {
                    color: $room-group-color;
                    font-size: 12px;
                    font-weight: 500;
                }

                .address {
                    color: $room-email-color;
                    font-size: 12px;
                    font-weight: 500;
                }
            }
        }
    }

    .calender-right {
        height: 100%;
        overflow-x: auto;
        position: relative;
        color: #3a4245;
        overflow-y: hidden;
        background-color: white;

        .wrapper {
            .rule {
                .calender-heading-trow {
                    height: 80px;

                    .cell {
                        width: 14.28%;
                        height: 100%;
                        float: left;
                        border-left: 1px solid $border-left-color;
                        position: relative;
                        border-bottom: 1px solid $border-color;

                        .day-text {
                            font-size: 30px;
                            line-height: 30px;
                            font-weight: 200;
                            color: $title-color;
                            margin: 17px 0 0 7px;

                            .week {
                                position: absolute;
                                bottom: 0;
                                width: 100%;
                                line-height: 10px;
                                left: 0;

                                span {
                                    color: #576B70;
                                    padding-left: 7px;
                                    font-size: 16px;
                                    font-weight: 500;
                                    position: relative;
                                    top: -10px;
                                    display: block;
                                }
                            }
                        }
                    }

                }
            }

            .calender-meeting {
                .calender-body-trow {
                    height: $cell-height;
                    position: relative;

                    .cell {
                        width: 14.28%;
                        height: 100%;
                        float: left;
                        border-left: 1px solid $border-left-color;
                        position: relative;
                        border-bottom: 1px solid $border-color;
                        user-select: none;
                        overflow: hidden;
                        padding: 2px;

                        .details {
                            position: absolute;
                            left: 0;
                            right: 0;
                            top: 0;
                            bottom: 0;
                            background-color: rgba(240, 248, 255, 0.95);
                            text-align: center;
                            transition: opacity 0.2s ease-in;
                            line-height: $cell-height;
                            opacity: 0;
                        }

                        &:hover {
                            .details {
                                display: block;
                                opacity: 1;
                            }
                        }

                        .book {
                            position: relative;
                            text-align: left;

                            display: block;
                            width: 100%;
                            height: 28px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            font-size: 14px;
                            line-height: 18px;
                            color: #576B70;

                            span {
                                font-family: Helvetica Neue, PingFang SC, Helvetica, Arial, Hiragino Sans GB, Microsoft Yahei, sans-serif;
                                display: inline-block;
                                position: relative;
                                top: 1px;
                                font-weight: 500;
                                padding: 0 2px;
                                color: #fff;
                                margin-left: 1px;
                            }


                            &.submitted {
                                span {
                                    background-color: #1976d2;
                                }
                            }

                            &.approved {
                                span {
                                    background-color: #388E3C;
                                }
                            }

                            &.other {
                                background-color: #FFF3E0;
                                border: 1px solid #cfd8dc;
                            }
                        }
                    }
                }
            }
        }
    }
}

.meeting-detail-wrap {
    .meeting-detail {
        border-bottom: 1px solid $border-color;
        margin-bottom: 15px;
        padding-bottom: 10px;

        .circle-number {
            width: 32px;
            height: 32px;
            border: 1px solid #607D8B;
            border-radius: 50%;
            line-height: 30px;
            text-align: center;
            font-size: 16px;
            color: #607D8B;
            float: left;
            font-weight: bold;
        }

        .meeting-inner {
            position: relative;
            user-select: none;
            font-weight: normal;
            padding-left: 64px;

            .name {
                font-size: 16px;
                font-weight: 600;
                line-height: 16px;
                color: #3a4245;
                height: 18px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .time {
                font-size: 14px;
                color: indianred;
            }

            .department {
                font-size: 14px;
            }

            .author {
                font-size: 14px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: #333;
            }

            .h323 {
                position: absolute;
                bottom: 0;
                right: 2px;
                font-size: 6px;
                color: rgba(255, 0, 0, 0.2);
            }
        }

        &:last-child {
            border-bottom: 1px solid transparent;
        }
    }

}

</style>
